import { absoluteUrl, breadcrumbJsonLd } from "@car/api/seo";
import { env } from "@car/env/web";

/** The public site's address: canonical links, link previews, sitemap.xml */
export const siteUrl = env.VITE_SITE_URL;

/** A site path as an absolute URL (an image already on the bucket stays as it is) */
export const siteHref = (path: string) => absoluteUrl(siteUrl, path);

const BRAND = "تابان خودرو";

/**
 * A page's title with the brand after it. A page named in the panel often carries the brand
 * already («درباره تابان خودرو»), and «… | تابان خودرو» on top of that reads as a stutter in
 * the result and eats the width Google gives the title.
 */
export const pageTitle = (title: string) => (title.includes(BRAND) ? title : `${title} | ${BRAND}`);

/**
 * A page's title and description plus their Open Graph copies for link previews in
 * Telegram and WhatsApp (Twitter reads og:* too). The root route adds the site-wide
 * og:* tags, the canonical link and the default image; a page's `image` replaces it.
 */
export const pageMeta = (title: string, description: string | undefined, image?: string) => [
  { title },
  { name: "description", content: description },
  { property: "og:title", content: title },
  { property: "og:description", content: description },
  ...(image ? [{ property: "og:image", content: siteHref(image) }] : []),
];

/**
 * «خانه ‹ این صفحه» زیر نشانی، در نتیجه‌های جستجو. برای صفحه‌هایی که یک پله زیر خانه‌اند؛
 * «خودروها ‹ یک مدل» سه پله است و در خودِ آن صفحه ساخته می‌شود.
 */
export const pageCrumbs = (name: string, path: string) => ({
  "script:ld+json": breadcrumbJsonLd(siteUrl, [
    { name: "خانه", path: "/" },
    { name, path },
  ]),
});
